<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="save(f)">
  <div class="modal-header">
    <h5
      class="modal-title"
      [xdaTranslate]="type == 0 ? 'SDE_EDIT_EMAIL2' : 'SDE_EDIT_DOMAIN'"></h5>
  </div>
  <div class="modal-body modal-centered">
    <div class="form-group">
      <xrx-input
        type="text"
        id="address"
        name="address"
        [(ngModel)]="address"
        [maxlength]="maxlength"
        [placeholder]="type == 0 ? 'SDE_EMAIL2' : 'SDE_DOMAIN'"
        [autofocus]="true"
        [error]="error"></xrx-input>
    </div>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button type="submit" class="xrx-btn btn-primary">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
</form>
